import React from "react";

import { useGroupBy } from "../../../../../../../utils/Context/TaskGroupByContext";
import DropdownSelect from "../../../../../../ui/dropdown/DropdownSelect";
import Iconify from "../../../../../../../layouts/components/iconify/iconify";
import { DropdownWrapper } from "../../../../../../ui/dropdownwrapper/DropdownWrapper";
import { TASK_SORT_OPTIONS, TASK_SORT_ORDER_OPTIONS } from "../../../../../../tasks/taskGridColumns";

import "./GroupByDropdown.scss";

const sortOptions = TASK_SORT_OPTIONS;

const orderOptions = TASK_SORT_ORDER_OPTIONS;

const SortDropdown = () => {
  const {
    selectedSort,
    selectedOrder,
    setSelectedSort,
    setSelectedOrder,
  } = useGroupBy();

  const sortLabel = selectedSort?.label || "Task ID";
  const orderLabel = selectedOrder?.value === "DESC" ? "Desc" : "Asc";
  const isCustomSort =
    (selectedSort?.value && selectedSort.value !== "TaskId") ||
    selectedOrder?.value === "DESC";

  return (
    <DropdownWrapper
      className={"group-by-dropdown"}
      toggleElement={
        <div className={`group-by-btn ${isCustomSort ? "active" : ""}`}>
          <button type="button">
            <Iconify icon="mdi:sort" width={16} />
            <span>Sort : {sortLabel} ({orderLabel})</span>
          </button>
        </div>
      }
    >
      <div className="selected-option-content">
        <div className="group-by-title">Sort</div>
        <div className="group-options">
          <div className="group-by-project">
            <DropdownSelect
              placeholder="Sort by"
              value={selectedSort || sortOptions[0]}
              optionsValue={sortOptions}
              handleDropdownChange={setSelectedSort}
            />
          </div>
          <div className="group-by-order">
            <DropdownSelect
              placeholder="Order"
              value={selectedOrder || orderOptions[0]}
              optionsValue={orderOptions}
              handleDropdownChange={setSelectedOrder}
            />
          </div>
        </div>
      </div>
    </DropdownWrapper>
  );
};

export default SortDropdown;
